import Marquee from "react-fast-marquee";

const fallback = [
  "Cook", "Pack", "Deliver", "Serve", "Welcome", "Share a cuppa", "Wash up", "Give Christmas",
];

export const Ribbon = ({ c }) => {
  const items = (c?.ribbon_words && c.ribbon_words.length ? c.ribbon_words : fallback);
  return (
    <section
      data-testid="marquee-ribbon"
      className="bg-[#F2E8D5] border-y border-[#8E1226]/10 py-6 md:py-8 overflow-hidden"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((it, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-serif italic text-[#8E1226] text-4xl md:text-6xl px-10 md:px-16">
              {it}
            </span>
            <span className="text-[#0E6B3A] text-2xl md:text-3xl">✳</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
